<template lang="pug">
  form(action="#" @submit.prevent="login")
    .form-group.mb-3
      label Usuario
      input.form-control(type="text" v-model="user" required="true")
    .form-group.mb-4
      label Contraseña
      input.form-control(type="password" v-model="password" required="true")
    .form-group.mb-2
      button#buttonGetIn.w-100(type="submit") Entrar
    .form-group.text-center.mb-0
      router-link(to="contrasena") ¿Olvidaste tu contraseña?
</template>

<script>
import LoginLayout from '@/layouts/LoginLayout'
import { appisAmulenCore } from '../utils/axiosInstances'

export default {
  name: 'login',
  data () {
    return {
      user: '',
      password: '',
      clientId: ''
    }
  },
  created () {
    this.$emit('update:layout', LoginLayout)
  },
  methods: {
    async login () {
      const rtta = sessionStorage.getItem('rtta')
      try {
        await this.$store.dispatch('retrieveSession', {
          user: this.user,
          password: this.password,
          client: this.clientId
        })
        if (rtta) {
          sessionStorage.removeItem('rtta')
          this.$router.push(rtta)
        } else {
          this.$router.push('/')
        }
      } catch (error) {
        alert('Usuario o contraseña incorrectos')
      }
    },
    async getClientIdAndLogin () {
      const hostname = window.location.hostname
      localStorage.setItem('hostname', hostname)
      const amulenClientsData = await appisAmulenCore.get('/client')
      const client = amulenClientsData.data.message.find(
        x => x.url === hostname
      )
      if (client) {
        this.clientId = client.id
        localStorage.setItem('clientId', this.clientId)
        localStorage.setItem('clientName', client.name)
      }
    }
  },
  async mounted () {
    await this.getClientIdAndLogin()
  }
}
</script>

<style lang="stylus">
  #buttonGetIn
    border: none
    color: white
    border-radius: 6px
    height: 40px;
    background: #43ADE1
  #buttonGetIn:hover
    background: #2D9CD3
</style>
